var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBuyerBenefits1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 81 75.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-2,.cls-3,.cls-5{fill:none;}.cls-2,.cls-3,.cls-4,.cls-6{stroke:#fff;}.cls-2{stroke-linecap:round;stroke-linejoin:round;}.cls-3,.cls-4,.cls-5,.cls-6{stroke-miterlimit:10;}.cls-4{mix-blend-mode:screen;opacity:0.52;fill:url(#radial-gradient);}.cls-5{stroke:#4d4d4d;}"), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 40.63,
    cy: 41.63,
    r: 18.22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#dadada",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#8d8d8d",
    stopOpacity: 0.94
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#505050",
    stopOpacity: 0.97
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#252525",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#0a0a0a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_4",
    "data-name": "Layer 4"
  }, /*#__PURE__*/React.createElement("image", {
    width: 81,
    height: 65,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFEAAABBCAYAAACpWUitAAAACXBIWXMAAAsSAAALEgHS3X78AAAE/ElEQVR4Xu2b4XaiShCEP9TEJPv+j7r3JkZlfwy1U4woA0w2o6HOmQNBhemiprvpDk3btqxYhs3YF1aMYyWxAHZjX/gmNMkWoE221aBGEptkbIAzgbwqiayVxA2w7bY74Egg8kQktBrURqLUtwWebHx2AwKBDRURWRuJEEl8Bl6AN+C/7rjUWBVqIzFV4gvwSiTv075TjRJrTHHkE3fd2Nv+hn7ErgJLlfgVqUgamTX8+BKkv587z79YQuJXpSKtjbMNPz4HfgO09XPNPe8iEiH6Lw35LqUiMH1yIu/YjQ/bn5veDKkaLlOmOeeeTaKrb0dMRc7EdGSO0VKagsg74Rrv3d8n+04uNM8tfd/qN0rnnYW5JEJUoZz/C2FiB2LAOjLdaJF46PaPxBsz1dj0Ru+7bUM41wdR+bMj/hISBd3lJ8IkRGDq23Im6Eqk2/pSnqLENF16JeScIvGTeC13P5OxhEQnSCRtiXd0yOgc4510KWZuYJEK90QSNwQCz8mYjbl5ogyRX/kkLL8T/eUj/zPlOunNOdr+FBKHlvJzd9z94dTzXmCpEjWZA0GFEM7pztxzvNyJTlHuLQzNQ0FLwW+qn71ACRIhPo6dCXfbc8alyfFceF4opemGa3y7EqGvRmx/2302Ny0pgZZ+qgRhXh/dkPvJDXpXsZRE6BOpifvSWbxcZsLnpVWioLI0ee+hBIkQJ9zSfyLwIPEd0E3VUvZoX4RAgKZwy/RLnk0XwOeTzqmYiylNYq1Ig1tRo0st59pRlLQUU5LgFVewklgAK4kFcM0nfqkjfjSkJHpK4Cr1dCDdPiKuPaoO2uwkKpdS1UUP7a2NtJpSLNeqACLOCyZCam/P5iElqoj5bJ+rNqih6oeeRO6dSBeQ94xUeXLbL2xOlehFzDcCkfqB1w0/7PijEKhWx3M3nrrPzwS7r9qcKtFJ/EWoBuvhXeSpzHUiTuARiNS/rrwR+kX77jMRKFcmuweVCJfrXku7IS7vhn5B87uKC6Xgy1gkSkAtseAsmyWiv3ASFTjU6/3dHXO/eCC2L1VKegT4ct7Rr4eq/qja6IXNQ0oUiRB+JAcrKR+IjZ5H8InQt/t3t78jVsKdxJs+UUoU5FAV8vW5R6pHIdAFIne1IWYi3oi7sHlIiVKYTjCWLz0KkaduXxVwX33aDtp8q57YJFuhTbaPgGZgQKZgfkpRNhepYCBDLD+lKJuLUcKGsJbCCmAlsQBWEgtgJbEAVhILYCWxAFYSC2BqnvhoTzHX7JiEXBJ1Me8/6Jietc/cT4HWxeCF5Vn1gBwSdRE1rtR/gHAxFWfhPuqLsscbcio2eMEBMskcI9GrvnpXRUVLCBf03sO9QKKQTVv6ZS8vOI/adYtEJ1Cvzb4QLqpWql5jGOw9VArZpabUa7eveqJclq+wmzblKFEXU+/B+ywi7t6QNuT2xFWl5Q1RINofRI4SRaKUCPHfddM3nWpXoZAGkbTPLPKyWiA5SvRIrLbAAfif/jt39xBUIBKk/sk7/WApX6key6ibGiPRu38bYp9BXbBirzH8Yyir8PcQn4lE+r/RXLRIU9wi0e+Y7oRHMY17XMoiRS9hnohRWkHFX9G4iTEl6gLaej6V7TMqRBowtLrcL2b7+rEeS9HMvkK4XVq67v9dJFdtHSNRSNOYrB/dETx4enrT2v5V5JL4UzBLLGM+8achi7QUfwDX/k1XPB08JgAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 15.52,
    y1: 54.99,
    x2: 10.64,
    y2: 57.74
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 12.63,
    y1: 35.87,
    x2: 6.83,
    y2: 34.79
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 22.56,
    y1: 19.51,
    x2: 18.66,
    y2: 14.76
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 40.6,
    y1: 7.02,
    x2: 40.54,
    y2: 13.22
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 62.38,
    y1: 15.19,
    x2: 58.43,
    y2: 19.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 73.81,
    y1: 35.45,
    x2: 68.11,
    y2: 36.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 69.54,
    y1: 58.33,
    x2: 64.81,
    y2: 55.53
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M59.12,41.21A18.86,18.86,0,1,0,28.27,55.77a19.09,19.09,0,0,1,7,14.72v.59h10v-.59a19.46,19.46,0,0,1,7.15-14.84A18.79,18.79,0,0,0,59.12,41.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M59.12,41.21A18.86,18.86,0,1,0,28.27,55.77a19.09,19.09,0,0,1,7,14.72v.59h10v-.59a19.46,19.46,0,0,1,7.15-14.84A18.79,18.79,0,0,0,59.12,41.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M47.64,48.68C44,55.42,43.2,64.54,43.12,65"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M39,65c.05-.63,0-9.82-2.78-14.7"
  }), /*#__PURE__*/React.createElement("image", {
    width: 31,
    height: 35,
    transform: "translate(24 25)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB8AAAAjCAYAAABsFtHvAAAACXBIWXMAAAsSAAALEgHS3X78AAAC6ElEQVRYR8WX2XLbMAxFjywv2dv+/1e2k0SxFUl9AK4B0VS8tNNihkNxw8VGgGqmaeJ/0frchhuoqcxVNbwVvCn6ck7fU6Ud6RpwMVwRABlI33l9BIbUIAlwKbiYtUWrCaJ5MPA9cPDxwJXg0qYFNsDW24YAL/e1PjcCr+l79H0TXAe+Ae6AJ2CHCSANJ0Lrte+FABuBT0zzUYzPgcuUawzwEfgO3GOCQGgkc2ZXgAmyxgTT/MWar5iDv2AMG8yfe6DHtJKgm9TLFdlFwHnwHMFrQgOZ8B3osIAafN8WE3THXNtsDeA8ONQP98AHFkzvBHiLgetayUJSYCbAJeAw99WIgXUY8JuPRww8m78ngNWOvC4Fh8hQI8b0QNzhQ1prMI17zD21vADEVbmUsgBD0ZfZTGOBlppfDQ7LuXpKfb5+2eyzgLsF/CuqFZIyYG82+6UkgIlC20znwPM1KVtNo6U9VVqK9sxMyWVDZC4lmxJM97xMqVUqwTOoqth90VRUxDxnMRWfR9+7TWsnQVoDXxGl894ZPQHPBNOOKK3KZmsMWGdkKbn2y5dMBlYREeiTjx98vfM9d34uF54HbysMbO/8dQWPQpTg8tkj8AMrny/O7M7XJsLc8q1AJeSOeMXsmSejE7PLLy3z0vmMmVH7lL0+fSzwb35GZm+JNKwKmMFPNFdkb4mg2WFC5RdIj5m9dyY6Jx+3Pj9gWn9guV81vxpwtbsqJtlfHxi4fKknkwJLGnfAL6zsStiq2UmTAhr8wCqNB2f2igmBr+38W9GtcvvTW4eZfxEc4qHXY5opDqY09+bMOp9XLX8j7rzMrXq/d76LVy2bSybfMjd/T4Crhh8wxu9p7ydR5/XKmWkNAa4IHIgHvl4m0lxW0QNCZlxhQuVUWtb1E2CAJv2l5uum93dmKOHy+1uHFagiKTOm8Qk1xS9yWaHKopCjPgdorXhUATOV4Mf5ohdNRf9HtFRS/yrIEmU//XP6DcuyFrdH74D5AAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M36.63,49.91a5.16,5.16,0,0,0-.54-1.59c-.91-1.29-2.42-.94-3.57-.18a5,5,0,0,0-1.38,1.3,2.85,2.85,0,0,0-.5,1.81,1.59,1.59,0,0,0,.5,1.07,1.82,1.82,0,0,0,1.3.37,5,5,0,0,0,3.1-1,4.19,4.19,0,0,0,1.22-2.27A12.68,12.68,0,0,0,37,46.67c0-7.28-.46-13.27-.46-13.27l10.92-1.8c.1.76.18,1.52.26,2.29.18,1.77.32,3.55.41,5.32a34.49,34.49,0,0,1-.32,8.55c-.24,1.18-.47,2.28-1.58,2.92a5,5,0,0,1-4.21.17,1.61,1.61,0,0,1-.87-.73,1.59,1.59,0,0,1,.32-1.56,4.11,4.11,0,0,1,3.28-1.63c1.57,0,2.29,1,2.52,2.44"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 33.49,
    y: 65.8,
    width: 13.53,
    height: 3.07,
    rx: 1.29
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 33.49,
    y: 68.87,
    width: 13.53,
    height: 3.07,
    rx: 1.29
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 33.49,
    y: 71.94,
    width: 13.53,
    height: 3.07,
    rx: 1.29
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuyerBenefits1);
export default __webpack_public_path__ + "static/media/buyer_benefits_1.1d4f5414757964899dcbaae1a0aa250b.svg";
export { ForwardRef as ReactComponent };